module.exports = __webpack_public_path__ + "img/5.05ff192a.jpg";